import * as React from 'react';

const SvgServiceLogoBg = (props) => (
  <svg
    width='670'
    height='504'
    viewBox='0 0 670 504'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_13752_2006)'>
      <rect width='670' height='504' fill='none' />
      <g opacity='0.05'>
        <path
          d='M547.042 362.944L522.558 279.845C520.993 274.531 522.982 268.828 527.537 265.549L641.128 183.982C645.978 180.502 652.6 180.59 657.36 184.196L768.41 268.576C776.597 274.795 774.839 287.357 765.253 291.201L565.097 371.487C557.68 374.464 549.262 370.482 547.042 362.932V362.944Z'
          fill='#none'
        />
        <path
          d='M320.005 238.603L371.597 276.109C376.128 279.402 378.091 285.121 376.5 290.426L343.157 401.826C341.078 408.789 333.635 412.799 326.512 410.8L221.582 381.388C212.65 378.887 208.915 368.48 214.305 361.051L300.985 241.569C305.362 235.536 313.935 234.204 320.005 238.616V238.603Z'
          fill='#none'
        />
        <path
          d='M438.919 341.194L379.268 385.644C375.296 388.605 373.271 393.503 373.988 398.4L399.522 572H764.796L454.988 341.194C450.221 337.642 443.686 337.642 438.919 341.194Z'
          fill='#none'
        />
        <path
          d='M-37.5 -25L285.53 215.406C288.616 217.711 292.56 218.569 296.337 217.775L390.266 197.875C395.105 196.851 398.985 193.253 400.381 188.502L462.966 -25H-37.5Z'
          fill='#none'
        />
        <path
          d='M631.163 -25L475.905 99.3652C471.626 102.785 469.857 108.458 471.421 113.697L486.937 165.81C488.935 172.508 495.739 176.568 502.581 175.134L785.35 116.09V-25H631.163Z'
          fill='#none'
        />
      </g>
    </g>
    <defs>
      <clipPath id='service-logo-bg_svg__a'>
        <rect width='670' height='504' rx='8' fill='white' />
        <path transform='translate(-43 -93)' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgServiceLogoBg;
